import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import DiscordIcon from "../../../assets/Community/icons/discord.svg";
import AuxiliaryIcon from "../../../assets/Models/icons/models-auxiliary.svg";
import FoundationIcon from "../../../assets/Models/icons/models-foundation.svg";
import KnowledgeIcon from "../../../assets/Models/icons/models-knowledge.svg";
import copyApiImage from "../../../assets/Models/images/models-overview.png";
import ConsoleOverviewCards, { OverviewCardType } from "../../../components/Home/Overview/Cards/ConsoleOverviewCards";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import RequestAccessContainer from "../../../components/TailoredGeneration/RequestAccessContainer/RequestAccessContainer";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";
import { CrmEventTargets, CrmOrgEvents, CrmUserEvents } from "../../../constants/crm";
import { useAppStore } from "../../../hooks/useStores";
import { OrgFeatures } from "../../../models/billing";
import styles from "./ModelsOverview.module.scss";

const ModelsOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "models.overview" });
	const { t: tAccessModel } = useTranslation("translation", { keyPrefix: "models.access" });
	const { authStore } = useAppStore();
	const hasAccessToModels = authStore.isFeatureEnabled(OrgFeatures.FOUNDATION_MODELS);
	const cards: OverviewCardType[] = [
		{
			icon: FoundationIcon,
			title: t("cards.foundation.title"),
			description: t("cards.foundation.description"),
			link: RouterConstants.MODELS.FOUNDATION.fullPath,
		},
		{
			icon: AuxiliaryIcon,
			title: t("cards.auxiliary.title"),
			description: t("cards.auxiliary.description"),
			link: RouterConstants.MODELS.AUXILIARY.fullPath,
		},
		{
			icon: KnowledgeIcon,
			title: t("cards.knowledge.title"),
			description: t("cards.knowledge.description"),
			link: LinkConstants.BRIA_COOKBOOK,
			newTab: true,
		},
		{
			icon: DiscordIcon,
			title: t("cards.discord.title"),
			description: t("cards.discord.description"),
			link: LinkConstants.DISCORD_COMMUNITY,
			newTab: true,
		},
	];

	return (
		<ConsoleOverviewLayout
			className={styles.modelsOverviewContainer}
			copyApiTokenProps={{
				image: copyApiImage,
				description: t("copyApiToken.description"),
				primaryButton: !hasAccessToModels ? (
					<RequestAccessContainer
						showCrown={false}
						buttonClassName={styles.requestAccessBtn}
						requestFeature={tAccessModel("key")}
						requestTitle={tAccessModel("cards.step1.requestTitle")}
						requestMessage={tAccessModel("cards.step1.requestMessage")}
						submissionMessage={tAccessModel("cards.step1.submissionMessage")}
						buttonMessage={t("copyApiToken.primaryBtn")}
						crmEvents={[
							{
								eventTarget: CrmEventTargets.ORG,
								eventType: CrmOrgEvents.ORG_REQUESTED_FOUNDATION_MODELS,
							},
							{
								eventTarget: CrmEventTargets.USER,
								eventType: CrmUserEvents.USER_REQUESTED_FOUNDATION_MODELS,
							},
						]}
					/>
				) : (
					<BriaButton
						buttonType="primaryMedium"
						onClick={() => window.open(LinkConstants.BRIA_HUGGING_FACE, "_blank")}
					>
						{t("exploreHuggingFace.primaryBtn")}
					</BriaButton>
				),
				secondaryButton: (
					<BriaButton
						buttonType="primaryMedium"
						onClick={() => window.open(LinkConstants.BRIA_CONTACT_US_FOUNDATION_MODELS, "_blank")}
					>
						{t("exploreCommercialLicense.primaryBtn")}
					</BriaButton>
				),
				hideCopyTokenBtn: true,
			}}
			integrations={["HUGGING_FACE", "GITHUB", "FAL", "REPLICATE", "INVOKE", "AWS", "AZURE"]}
		>
			<ConsoleOverviewCards cards={cards} />
		</ConsoleOverviewLayout>
	);
};

export default observer(ModelsOverview);
